import * as ActionTypes from './ActionTypes';
import {baseUrl} from '../shared/baseUrl';
import React from 'react'
import { Redirect,browserHistory } from 'react-router';
import { nextTick } from 'q';

// let headers = new Headers();
// headers.append('Origin','http://localhost:3001');

export const updateStateAudio = (audioData) => ({
    type: ActionTypes.DOWNLOAD_FILE,
    payload: audioData
});

export const uploadAudio = (fileNumber,hindiTextId,audioBlob,language) => (dispatch) =>{
    
    // console.log('Base64 String - ', base64String);
    // reader.onloadend();
    console.log("Current lanugage is: "+language);
    console.log("Here Trying to upload, ",fileNumber);
    var sendPackage = {
        "fileNumber":fileNumber,
        "textInfo":hindiTextId,
        "audioBlob":audioBlob,
        "language":language
    }
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'audio',{
        method: 'POST',
        body: JSON.stringify(sendPackage),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
            // "Accept": "application/json",
            // "type": "formData"
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            // console.log("returned  response is a success");
            console.log(response);
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            console.log(response);
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>(response.json()))
    .catch((err)=>console.log(err));
};

export const downloadAudio = () => (dispatch) =>{
    
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'audio',{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            // console.log("returned  response is a success");
            // console.log(response);
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            // console.log(response);
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>{
        // console.log(response)
        return response.json()
    })
    .then(audioBase64=>{
        return dispatch(updateStateAudio(audioBase64));
    })
    .catch((err)=>console.log(err));
};


export const updateStateHindiText = (hindiText) => ({
    type: ActionTypes.DOWNLOAD_TEXT_FILE,
    payload: hindiText
});

export const downloadHindiText = () => (dispatch) =>{
    // console.log("In the download text refion");
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'hindiText',{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            // console.log("returned  response is a success");
            // console.log(response);
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            // console.log(response);
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>{
        // console.log("Inside Reponse\n",response)//
        return response.json()
    })
    .then(hindiText=>{
        return dispatch(updateStateHindiText(hindiText));
    })
    .catch((err)=>console.log(err));
};



// LOGIN

export const requestLogin = (creds) => {
    return {
        type: ActionTypes.LOGIN_REQUEST,
        creds
    }
}
  
export const receiveLogin = (response) => {
    return {
        type: ActionTypes.LOGIN_SUCCESS,
        token: response.token
    }
}
  
export const loginError = (message) => {
    return {
        type: ActionTypes.LOGIN_FAILURE,
        message
    }
}

export const loginUser = (creds) => (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    dispatch(requestLogin(creds))

    return fetch(baseUrl + 'users/login', {
        method: 'POST',
        headers: { 
            'Content-Type':'application/json' 
        },
        body: JSON.stringify(creds)
    })
    // .then(response => {
    //     if (response.ok) {
    //         return response;
    //     } else {
    //         var error = new Error('Error ' + response.status + ': ' + response.statusText);
    //         error.response = response;
    //         throw error;
    //     }
    //     },
    //     error => {
    //         throw error;
    //     })
    .then(response => response.json())
    .then(response => {
        if (response.success) {
            // If login was successful, set the token in local storage
            localStorage.setItem('token', response.token);
            localStorage.setItem('username',creds.username);
            localStorage.setItem('hindiText',JSON.stringify({
                hindiTextId:"",
                hindiText:"",
                fileNumber:""
            }));
            localStorage.setItem('isAdmin', response.admin);
            // Dispatch the success action
            dispatch(receiveLogin(response));
        }
        else {
            console.log(response);
            var error = new Error(response.error.message);
            error.response = response;
            throw error;
        }
    })
    .catch(error => dispatch(loginError(error.message)))
};


// LOGOUT
export const requestLogout = () => {
    return {
      type: ActionTypes.LOGOUT_REQUEST
    }
}
  
export const receiveLogout = () => {
    // window.location.href = "/login";
    return {
      type: ActionTypes.LOGOUT_SUCCESS
    }
}

// Logs the user out
export const logoutUser = () => (dispatch) => {
    var token = localStorage.getItem('token');
    localStorage.removeItem('token');
    localStorage.removeItem('audioVerification');
    localStorage.removeItem('audioVerifications');
    localStorage.removeItem('language');
    if(localStorage.getItem('isAdmin')){
        localStorage.removeItem('isAdmin');
    }
    dispatch(receiveLogout());
    var putText = [];

    var hindiTexts = localStorage.getItem('hindiTexts');
    if (hindiTexts) {
        var nextItem = JSON.parse(hindiTexts).array;
        for(let i=0;i<nextItem.length;++i){
            putText.push(nextItem[i]._id);
        }
        localStorage.removeItem('hindiTexts');
    }

    const bearer = 'Bearer ' + token;
    return fetch(baseUrl + 'hindiText/batchGet', {
        method: 'PUT',
        headers: { 
            'Content-Type':'application/json',
            'Authorization': bearer
        },
        body: JSON.stringify({
            hindiTextId: putText
        })
    })
    .then(response => {
        if (response.ok) {
            return response;
        } else {
            var error = new Error('Error ' + response.status + ': ' + response.statusText);
            error.response = response;
            throw error;
        }
        },
        error => {
            throw error;
        })
    .then(response => response.json())
    .then(response => {
        if (response.success) {
            console.log(response);
            localStorage.removeItem('hindiTexts');
        }
        else {
            var error = new Error('Error ' + response.status);
            error.response = response;
            throw error;
        }
    })
    .catch(err => console.log(err))
    // else{
    //     localStorage.removeItem('token');
    //     localStorage.removeItem('hindiText');
    //     dispatch(receiveLogout());
    // }
}


// SIGUP USER
export const signupUser = (info) => {
    // console.log(info)
    return fetch(baseUrl + 'users/signup', {
        method: 'POST',
        headers: { 
            'Content-Type':'application/json' 
        },
        body: JSON.stringify(info)
    })
    .then(response => response.json())
    .catch((err)=>console.log(err))
};

// Get Recorded
export const updateStatsLocal = (stats) => {
    return {
        type: ActionTypes.GET_STATS,
        payload:stats
    }
}

export const getStats = () => (dispatch) =>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'users/username/'+localStorage.getItem('username'),{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
            // "Accept": "application/json",
            // "type": "formData"
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        console.log(response);
        if(response.ok){
            // console.log("returned  response is a success");
            console.log(response);
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            console.log(response);
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>(response.json()))
    .then((stats)=>{
        console.log(stats);
        localStorage.setItem('verified', stats.verified);
        localStorage.setItem('recorded',stats.recorded);
        return stats;
    })
    // .then((stats)=>dispatch(updateStatsLocal(stats)))
    .catch((err)=>console.log(err));
};

// GET Verified

// export const getVerified = () => (dispatch) =>{
//     const bearer = 'Bearer ' + localStorage.getItem('token');
//     return fetch(baseUrl+'users/username/'+localStorage.getItem('username'),{
//         method: 'GET',
//         headers: {
//             "Content-Type": "application/json",
//             'Authorization': bearer
//             // "Accept": "application/json",
//             // "type": "formData"
//           },
//         credentials: 'same-origin'
//     })
//     .then(response =>{
//         if(response.ok){
//             // console.log("returned  response is a success");
//             // console.log(response);
//             return response;
//         }
//         else{
//             var error = new Error("Response failed!!");
//             error.response = response;
//             // console.log(response);
//             throw error;
//         }
//     },(err)=>{
//         var errmess = new Error(err.message+"hulalalala")
//         throw errmess;
//     })
//     .then(response=>(response.json()))
//     .then((stats)=>{
//         localStorage.setItem('verified', stats.verified);
//         localStorage.setItem('recorded',stats.recorded);
//         return stats;
//     }).
//     then((stats)=>dispatch(updateStatsLocal(stats)))
//     .catch((err)=>console.log(err));
// };

export const updateStatsServer = (recorded) => (dispatch) =>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'users/username/'+localStorage.getItem('username'),{
        method: 'PUT',
        body: JSON.stringify({
            recorded: recorded 
        }),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
            // "Accept": "application/json",
            // "type": "formData"
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            // console.log("returned  response is a success");
            console.log(response);
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            console.log(response);
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>(response.json()))
    .catch((err)=>console.log(err));
};

// Get AUDIO for verification
export const getAudioForVerification = (language)=>{
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+`audio/getFileAsync/${language}`,{
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response.json();
        }
        const error = new Error(`Error ${response.status}: ${response.statusText}`);
        error.response = response;
        throw error;
    })
    .catch(error => {
        console.error('Error fetching audio:', error);
        throw error;  // Re-throw to handle in component
    });
}

// verify Audio
export const audioVerificationResult = (audioId,verificationResult) =>(dispatch)=>{
    var dataload = {
        _id:audioId,
        verificationResult:verificationResult
    }
    const bearer = 'Bearer ' + localStorage.getItem('token');
    return fetch(baseUrl+'audio',{
        method: 'PUT',
        body: JSON.stringify(dataload),
        headers: {
            "Content-Type": "application/json",
            'Authorization': bearer
          },
        credentials: 'same-origin'
    })
    .then(response =>{
        if(response.ok){
            return response;
        }
        else{
            var error = new Error("Response failed!!");
            error.response = response;
            throw error;
        }
    },(err)=>{
        var errmess = new Error(err.message+"hulalalala")
        throw errmess;
    })
    .then(response=>{
        return response.json();
    })
    .catch((err)=>console.log(err));
}

// export const getAudioForVerification = () => {
//     const bearer = 'Bearer ' + localStorage.getItem('token');
    
//     return fetch(baseUrl + 'audio/verify', {
//         method: 'GET',
//         headers: {
//             "Content-Type": "application/json",
//             'Authorization': bearer
//         },
//         credentials: 'same-origin'
//     })
//     .then(response => {
//         if (!response.ok) {
//             throw new Error('Failed to fetch audio');
//         }
//         return response.json();
//     })
//     .then(data => {
//         if (!data.success) {
//             throw new Error(data.message || 'Failed to fetch audio');
//         }
//         return data;
//     });
// };

// // Submit verification result
// export const audioVerificationResult = (audioId, isCorrect) => {
//     const bearer = 'Bearer ' + localStorage.getItem('token');
    
//     return fetch(baseUrl + `audio/verify/${audioId}`, {
//         method: 'POST',
//         headers: {
//             "Content-Type": "application/json",
//             'Authorization': bearer
//         },
//         body: JSON.stringify({
//             isCorrect: isCorrect
//         }),
//         credentials: 'same-origin'
//     })
//     .then(response => {
//         if (!response.ok) {
//             throw new Error('Failed to submit verification');
//         }
//         return response.json();
//     })
//     .then(data => {
//         if (!data.success) {
//             throw new Error(data.message || 'Failed to submit verification');
//         }
//         return data;
//     });
// };